import PropTypes from 'prop-types';
import { Autocomplete, Checkbox } from '@mui/material';
import { Input } from '../index';

function ClinicMultiValueSelect({
    clinics,
    selectedClinics,
    onSelectClinics,
    disabled,
    required,
    errorText,
}) {
    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            disabled={disabled}
            className="form-field"
            options={clinics}
            renderInput={(props) => (
                <Input {...props} error={errorText} helperText={errorText} label={`Clinics ${required ? '*' : ''}`} />
            )}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option.id}>
                    <Checkbox
                        checked={selected}
                        size="small"
                        sx={{
                            marginRight: 1,
                            color: 'black',
                            '&.Mui-checked': {
                                color: 'black',
                            },
                        }}
                    />
                    {option.name}
                </li>
            )}
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={clinics.filter((clinic) => selectedClinics.includes(clinic.id))}
            onChange={(event, newValue) => {
                onSelectClinics(newValue.map((clinic) => clinic.id));
            }}
        />
    );
}

ClinicMultiValueSelect.propTypes = {
    clinics: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    })),
    selectedClinics: PropTypes.arrayOf(PropTypes.string),
    onSelectClinics: PropTypes.func,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    errorText: PropTypes.string,
};

ClinicMultiValueSelect.defaultProps = {
    clinics: [],
    selectedClinics: [],
    onSelectClinics: () => {},
    disabled: false,
    required: false,
    errorText: '',
};

export default ClinicMultiValueSelect;
